import React from 'react'
import Link, { navigateTo } from 'gatsby-link'
import Card, { CardActions, CardContent, CardHeader } from 'material-ui/Card'
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table'
import List, { ListItem, ListItemText } from 'material-ui/List'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography'

import Icon from '../components/icon'
import DiscordButton from '../components/discord_button'

import DeathKnight from '../images/classes/deathknight.svg'
import DemonHunter from '../images/classes/demonhunter.svg'
import Druid from '../images/classes/druid.svg'
import Hunter from '../images/classes/hunter.svg'
import Mage from '../images/classes/mage.svg'
import Monk from '../images/classes/monk.svg'
import Paladin from '../images/classes/paladin.svg'
import Priest from '../images/classes/priest.svg'
import Rogue from '../images/classes/rogue.svg'
import Shaman from '../images/classes/shaman.svg'
import Warlock from '../images/classes/warlock.svg'
import Warrior from '../images/classes/warrior.svg'

import Damage from '../images/roles/damage.svg'
import Healer from '../images/roles/healer.svg'
import Tank from '../images/roles/tank.svg'

const DesireHigh = (props) => (
  <TableCell {...props} className='table-cell red'>High</TableCell>
)

const DesireMedium = (props) => (
  <TableCell {...props} className='table-cell amber'>Medium</TableCell>
)

const DesireLow = (props) => (
  <TableCell {...props} className='table-cell green'>Low</TableCell>
)

const RecruitmentPage = () => (
  <div className='content'>
    <h1 style={{  paddingTop: '12px' }}>Recruitment</h1>
    <Card style={{ marginTop: '32px', padding: '16px' }}>
      <CardContent>
        <CardHeader classes={{ root: 'card-header'}} title="Adventure is in Open Recruitment!" />
        <Typography style={{ marginBottom: '16px' }} component="p">
          Adventure is recruiting new members. If you are looking for a raid position please visit the <Button dense color='primary' onClick={()=> navigateTo('/apply')}>Apply</Button> page and fill out an application.
          If you are just looking to join in on the fun without raiding, click the discord invite button <DiscordButton style={{ position: 'relative', marginRight: '38px' }} svgStyle={{ position: 'absolute', bottom: '-8px' }} /> at anytime.
        </Typography>
        <h3 style={{ marginBottom: '.5em' }}>
          Guild Information
        </h3>
        <List>
          <ListItem classes={{ default: 'list-item' }}>
            <ListItemText classes={{ root: 'list-item-text'}} primary='Faction' secondary='Horde' />
            <ListItemText classes={{ root: 'list-item-text'}} primary='Progression' secondary='Semi-hardcore (Mythic)' />
          </ListItem>
          <ListItem classes={{ default: 'list-item' }}>
            <ListItemText classes={{ root: 'list-item-text'}} primary='Realm' secondary='US - Illidan' />
            <ListItemText classes={{ root: 'list-item-text'}} primary='Realm Timezone' secondary='Central Time (CT)' />
          </ListItem>
          <ListItem classes={{ default: 'list-item' }}>
            <ListItemText classes={{ root: 'list-item-text'}} primary='Raid Schedule' secondary='Tuesday, Wednesday, & Pug Weekend (Optional)' />
            <ListItemText classes={{ root: 'list-item-text'}} primary='Raid Times' secondary='7pm - 10pm (CT)' />
          </ListItem>
        </List>
        <h4>Desired Classes and Roles</h4>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className='table-cell'>Class</TableCell>
              <TableCell className='table-cell'>Role</TableCell>
              <TableCell className='table-cell'>Desire</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className='table-cell'><Icon icon={Warrior} /></TableCell>
              <TableCell className='table-cell'><Icon icon={Damage} /></TableCell>
              <DesireHigh />
            </TableRow>
            <TableRow>
              <TableCell className='table-cell'><Icon icon={Warlock} /></TableCell>
              <TableCell className='table-cell'><Icon icon={Damage} /></TableCell>
              <DesireHigh />
            </TableRow>
            <TableRow>
              <TableCell className='table-cell'><Icon icon={Mage} /></TableCell>
              <TableCell className='table-cell'><Icon icon={Damage} /></TableCell>
              <DesireHigh />
            </TableRow>
            <TableRow>
              <TableCell className='table-cell'><Icon icon={Hunter} /></TableCell>
              <TableCell className='table-cell'><Icon icon={Damage} /></TableCell>
              <DesireMedium />
            </TableRow>
            <TableRow>
              <TableCell className='table-cell'><Icon icon={Monk} /></TableCell>
              <TableCell className='table-cell'><Icon icon={Damage} /></TableCell>
              <DesireHigh />
            </TableRow>
            <TableRow>
              <TableCell className='table-cell' style={{ borderBottom: 'none' }}><Icon icon={Paladin} /></TableCell>
              <TableCell className='table-cell'><Icon icon={Healer} /></TableCell>
              <DesireLow />
            </TableRow>
            <TableRow>
              <TableCell className='table-cell'><Icon icon={Rogue} /></TableCell>
              <TableCell className='table-cell'><Icon icon={Damage} /></TableCell>
              <DesireHigh />
            </TableRow>
            <TableRow>
              <TableCell className='table-cell'><Icon icon={Shaman} /></TableCell>
              <TableCell className='table-cell'><Icon icon={Healer} /></TableCell>
              <DesireLow />
            </TableRow>
          </TableBody>
        </Table>
        </CardContent>
      <CardActions>
        <Button dense onClick={()=> navigateTo('/apply')}>Apply</Button>
      </CardActions>
    </Card>
  </div>
)

export default RecruitmentPage



// WEBPACK FOOTER //
// ./src/pages/recruitment.js